import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable()
export class ReportDataService {
    url = environment.url;

   constructor(private http: HttpClient){}

   //INVOICE VERIFICATION
   public getInvoiceVerificationData(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/invoiceV2`, payload);
   }

   //CARTON RECONCILIATION
   public getCartonRecData(payload: any): Observable<any> {
    //return this.http.post("./json/cartonRec.json", payload)
    return this.http.post(`${this.url}report/getCartonReconcilationV2`, payload);
   }

   //KITTING SUMMARY
   public getKittingSummaryData(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/kittingSummaryV2`, payload);
   }

   //PALLET DETAIL
   public getPalletDetailData(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/palletDetailsV2`, payload);
   }

   //USED PALLET
   public getUsedPalletData(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/usedPalletReportV2`, payload);
   }

    //OUTBOUND REPORT
    public getOutboundReport(payload: any): Observable<any> {
        //return this.http.post("./json/outbound-data.json", payload);
        return this.http.post(`${this.url}report/outboundSummaryReportV2`, payload);
    }

    //TEAM REPORT
    public getTeamReport(payload: any): Observable<any> {
        return this.http.post(`${this.url}report/teamSummaryReportV2`, payload);
    }

    //TEAM REPORT
    public errorReport(payload: any): Observable<any> {
        return this.http.post(`${this.url}report/outboundErrorReport`, payload);
    }

   //DOWNLOAD INVOICE REPORT
   public downloadInvoiceReport(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadInvoiceV2`, payload);
   }

   //DOWNLOAD RECONCILIATION REPORT
   public downloadCartonRecReport(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadReconciliationV2`, payload);
   }

   //DOWNLOAD KITTING SUMMARY
   public downloadKittingSummary(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadKittingSummaryV2`, payload);
   }

   //DOWNLOAD PALLET DETAIL
   public downloadPalletDetail(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadPalletDetailsV2`, payload);
   }

   //DOWNLOAD USED PALLET REPORT
   public downloadUsedPallet(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadUsedPalletReportV2`, payload);
   }

   //DOWNLOAD OUTBOUND REPORT
   public downloadOutbound(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadOutboundSummaryReportV2`, payload);
   }

   //DOWNLOAD TEAM REPORT
   public downloadTeam(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadTeamSummaryReportV2`, payload);
   }

   //DOWNLOAD TEAM REPORT
   public downloadErrorReport(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadOutboundErrorReport`, payload);
   }

   public downloadDcErrorReport(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadDcErrorReportV2`, payload);
    //return this.http.post("./json/dc-error.json", payload);
   }

   public downloadKitCartonReport(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadKitCartonReportV2`, payload);
    //return this.http.post("./json/dc-error.json", payload);
   }

   public dcErrorReports(payload: any): Observable<any> {
     return this.http.post(`${this.url}report/dcErrorReportV2`, payload);
    //return this.http.post("./json/dc-error.json", payload);

   }

   //KIT-CARTONS REPORT
    public getKitCartonsReport(payload: any): Observable<any> {
        return this.http.post(`${this.url}report/kitCartonReportV2`, payload);
    }

    //DOWNLOAD BOL
    public downloadBol(bol: any, lob: any): Observable<any> {
        return this.http.get(`${this.url}spirit/downloadBolPdf/${bol? `${bol}?` : '?'}lob=${lob}`, {responseType: "arraybuffer"})
    }
    //CARTONS-DWELL-TIME REPORT
    public getCartonDwellTimeReport(payload: any): Observable<any> {
        return this.http.post(`${this.url}report/cartonDwellTimeReportV2`, payload);
    }

    public downloadCartonDwellTimeReport(payload: any): Observable<any> {
    return this.http.post(`${this.url}report/downloadCartonDwellTimeReportV2`, payload);
    //return this.http.post("./json/dc-error.json", payload);
   }
}